import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import { useRef } from 'react';
import useContainerSize from '@/hooks/useContainerSize';
import useSelections from '@/components/widget/misc/useSelections';
import { getEditingAreaAttr } from '@/components/Editor/hooks/useEditingAreas';
import { hasAnySelectionData, hasSelections } from '../../utils/selections';
import useData from './useData';
import useSubscribeWidgetResults from '../hooks/useSubscribeWidgetResults';
import Row from './Row';
import settings, { selectionConfigDefault, selectionConfigGroups } from './settings';
import Header from '../misc/Header';
import StyleVariables, { getSectionAttr, getSectionAttrSelector } from '../../misc/StyleVariables';
import styles from './styles.module.scss';
import Loading from './Loading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const StackedBars = _ref => {
  let {
    widgetId,
    sectionId,
    reportingWidgetId,
    elementId,
    config,
    editing = false,
    isLargeContainer
  } = _ref;
  const {
    seriesOptions = [],
    headings = [],
    selections = '',
    selectionsStrategy = '',
    selectionsLabeled = false
  } = config;
  const isLarge = isLargeContainer;
  const results = useSubscribeWidgetResults(reportingWidgetId); // Get relevant results for each selection group

  const {
    selectionResults
  } = useSelections({
    results,
    selections,
    selectionConfig: selectionsStrategy === 'groups' ? selectionConfigGroups : selectionConfigDefault,
    selectionsLabeled
  }); // Combine results with rendering styles

  const {
    data,
    maximum
  } = useData({
    results: selectionResults,
    seriesOptions,
    selectionsStrategy
  }); // Data & Loading States

  const hasNoData = !hasAnySelectionData(selectionResults);
  const isLoading = !results.length;
  const needSelectionEditing = editing && !hasSelections(selections); // Responsive queries

  const containerEl = useRef(); // TODO: replace with react-use

  const containerSize = useContainerSize(containerEl);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    /*
    // @ts-ignore */
    ref: containerEl
  }, elementId && {
    id: elementId
  }), {}, {
    className: clsx(styles.container, isLarge ? styles['container--large'] : '')
  }, getSectionAttr(widgetId, sectionId)), needSelectionEditing ? {
    [getEditingAreaAttr()]: 'na'
  } : null), {}, {
    children: [/*#__PURE__*/_jsx(Header, {
      editing: editing,
      config: config,
      widgetId: widgetId,
      sectionId: sectionId
    }), headings.filter(Boolean).length > 0 ? /*#__PURE__*/_jsxs("hgroup", {
      className: styles.container__header,
      children: [/*#__PURE__*/_jsx("h3", {
        className: clsx(styles.heading, styles['heading--loser']),
        children: headings[0] || 'Unnamed'
      }), /*#__PURE__*/_jsx("h3", {
        className: clsx(styles.heading, styles['heading--winner']),
        children: headings[1] || 'Unnamed'
      })]
    }) : /*#__PURE__*/_jsx(_Fragment, {}), isLoading || hasNoData ? /*#__PURE__*/_jsx(Loading, {}) : /*#__PURE__*/_jsx("ul", {
      className: styles.container__list,
      children: data.map((item, i) => /*#__PURE__*/_jsx(Row, {
        maximum: maximum,
        item: item,
        isLast: i + 1 === data.length,
        containerWidth: containerSize.width,
        editing: editing
      }, `${i}-${item.selections}`))
    }), /*#__PURE__*/_jsx(StyleVariables, {
      selector: getSectionAttrSelector(widgetId, sectionId),
      data: _objectSpread(_objectSpread({}, settings.styles), config.styles || {})
    })]
  }));
};

export default StackedBars;
export { settings };
export const configs = {
  ['default']: selectionConfigDefault,
  groups: selectionConfigGroups
};